import styles from "./SectionTitle.module.scss";

const SectionTitle = ({ data }) => {
    const { title } = data;
    const theme = localStorage.getItem("theme");

    return (
        <div className={styles.titleContainer} data-theme={theme}>
            <span className={styles.indicator} data-theme={theme}></span>
            <span className={styles.title} data-theme={theme}>
                {title}
            </span>
        </div>
    );
};

export default SectionTitle;
